module.exports = __webpack_public_path__ + "static/banner-mobile-24cd84dfb39b2e499810c6f80b0de59d.png";